import * as React from 'react'
import crossIcon from '$icons/cross.svg'
import styled from 'styled-components'
import { Icon } from '../Icon'
import { rem } from 'polished'
import { Link } from '../Link'
import { css } from '$utils/theme'
import { routeProvider } from '../../../utils/routeProvider'
import { Block } from '../Layout/Block'

const logo = require('$icons/logoFamiliados.svg')

interface Props {
  className?: string
  onClose?: () => void
  hasLogo?: boolean
  noPadding?: boolean
  noHeader?: boolean
  full?: boolean
  autoWidth?: boolean
  review?: boolean
  cookies?: boolean
  alignTop?: boolean
}

const StyledContainer = styled.div<{ alignTop?: boolean }>`
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: ${p => (p.alignTop ? 'flex-start' : 'center')};
  overflow-y: hidden;
  z-index: 10 !important;
  ${p =>
    p.theme.media.desktop`
      background-color: rgba(0, 0, 0, 0.75);
      overflow-y: auto;
      padding-top: 5rem;
      padding-bottom: 5rem;
    `};
`
export const StyledPaper = styled.div<Props>`
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${p => p.theme.colors.white};
  overflow: auto;
  ${p =>
    p.theme.media.desktop`
      max-width: ${p.cookies ? '40rem' : '30rem'};
      width: ${p.autoWidth ? 'auto' : '100%'};
      height: ${p.full ? '100%' : 'auto'};
    `};
  ${p =>
    p.review &&
    p.theme.media.desktop`
        max-height: 85%;
    `};
`

const StyledHeader = styled.div.attrs({})<Props>`
  display: flex;
  justify-content: ${p => (p.hasLogo ? 'space-between' : 'flex-end')};
  align-items: center;
  flex-shrink: 0;
  ${p =>
    p.theme.media.onlyMobile`
      padding-bottom: 0;
      height: 50px;
    `};
  height: 60px;
  padding: ${p => rem(p.theme.sizes.mini)};
  padding-top: ${p => rem(p.theme.sizes.base)};
  ${p =>
    p.review &&
    p.theme.media.desktop`
      padding-left: 3.5rem;
      padding-right: 2.5rem;
      padding-top: ${rem(p.theme.sizes.small)};
  `} ${p =>
    p.hasLogo &&
    css`
      border-bottom: solid 1px ${p.theme.colors.xlightGrey};
      box-shadow: 0 3px 6px -6px rgba(0, 0, 0, 0.1);
    `};
`

const StyledContent = styled.div.attrs({})<Props>`
  padding: ${p => rem(p.theme.sizes.medium)};
  padding-top: ${p => rem(p.theme.sizes.base)};
  ${p =>
    p.review &&
    p.theme.media.desktop`
      padding-left: 3.5rem;
      padding-right: 3rem;
      padding-bottom: ${rem(p.theme.sizes.huge)};
  `};
  ${p =>
    p.hasLogo &&
    css`
      padding: ${rem(p.theme.sizes.mini)};
    `};
  ${p =>
    p.noPadding &&
    css`
      padding: 0;
    `};
`

const StyledIcon = styled(Icon)`
  ${p => p.theme.media.onlyMobile`
    margin-right: 0;
  `};
`
const StyledBlock = styled(Block)`
  max-width: ${p => rem(p.theme.grid.contentMaxWidth.desktop)};
  margin: auto;
`

const StyledAreaIcon = styled.div`
  margin-top: 1rem;
  &:hover {
    cursor: pointer;
  }
  ${p => p.theme.media.onlyMobile`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${rem(48)};
    height: ${rem(48)};
    margin-right: -8px;
    margin-top: -8px;
 `};
`

export const ModalWindow: React.SFC<Props> = ({
  hasLogo,
  noPadding,
  children,
  onClose,
  full = false,
  autoWidth = false,
  noHeader,
  review,
  cookies,
  alignTop,
}) => {
  return (
    <StyledContainer alignTop={alignTop}>
      <StyledPaper full={full} autoWidth={autoWidth} review={review} cookies={cookies}>
        {!noHeader && (
          <>
            <StyledHeader hasLogo={hasLogo} review={review}>
              {hasLogo && (
                <Link href={routeProvider.mainPage} title="familiados">
                  <Icon content={logo} logo />
                </Link>
              )}
              {onClose && (
                <StyledAreaIcon onClick={onClose}>
                  <StyledIcon content={crossIcon} size="m" color="darkGrey" />
                </StyledAreaIcon>
              )}
            </StyledHeader>
          </>
        )}
        <StyledContent review={review} hasLogo={hasLogo} noPadding={noPadding}>
          <StyledBlock>{children}</StyledBlock>
        </StyledContent>
      </StyledPaper>
    </StyledContainer>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ModalWindow/ModalWindow.tsx